module.exports = __webpack_public_path__ + "1e15bca0e3207fdc66fbd924067629aa.png";